module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/add-music-0be328946e8c346539f09b44e07f356f.svg";